module.exports = __webpack_public_path__ + "static/pech-chern-a45651343de2258a03bc2bfc528d56c3.webp";